import React from 'react';
import Button from './Button';

const PlayButton = ({ ...props }) => (
  <Button {...props} classes="play-button" faux>
    <span className="sr-only">Play Video</span>
  </Button>
);

export default PlayButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Buttons/PlayButton.js